module.exports = __webpack_public_path__ + "static/media/mundo-em-noticias-start.5be35462.png";